// import "../Foote/Footer.css";
import '../Foote/footer.css';
import logo from '../../assets/logo.png';
import { Facebook, Instagram,} from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { BsTwitterX } from "react-icons/bs";
import { FaGooglePlay } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-column">
            <div className="footer-logo">
              <img src={logo} alt="logo" />
            </div>
            <p className="footer-description">
              Tamil vokkaliga is a leading matrimony platform dedicated to helping individuals find their perfect life
              partner.
            </p>
            <div className="social-links">
              <a href="#" className="social-icon">
                <Facebook className="fab fa-facebook-f" />
              </a>
              <a href="#" className="social-icon">
                <Instagram className="fab fa-instagram" />
              </a>
              <a href="#" className="social-icon">
                <FaWhatsapp className="fab fa-twitter" />
              </a>
              <a href="#" className="social-icon">
                <BsTwitterX className="fab fa-linkedin-in" />
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#testimonials">Success Stories</a>
              </li>
              <li>
                <a href="#contact">Contact Us</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Services</h3>
            <ul className="footer-links">
              <li>
                <a href="#">Premium Membership</a>
              </li>
              <li>
                <a href="#">Relationship Counseling</a>
              </li>
              <li>
                <a href="#">Personalized Matching</a>
              </li>
              <li>
                <a href="#">Background Verification</a>
              </li>
              <li>
                <a href="#">Wedding Planning</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact Us</h3>
            <ul className="contact-info">
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>37-G, Abirami complex, First floor,
vadakku radha veedhi,
Dindigul-1.
</span>
              </li>
              <li>
                <i className="fas fa-phone"></i>
                <span>+91 9865354499, 7639348617.</span>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <span>info@tamilvokkaliga.com</span>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Get the App</h3>
            <div className="app-download">
              <a 
                href="/matrimony/app"  
                 
                rel="noopener noreferrer"
                className="play-store-link"
              >
                <FaGooglePlay className="play-store-icon" />
                <div className="app-download-text">
                  {/* <span className="download-text">Download on</span> */}
                  <span className="store-name">Get Our App</span>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} Tamil Vokkaliga Matrimony, All Rights Reserved. Design & Developed by Virtual Technology.</p>
          </div>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms of Service</Link>
            <Link to="/refund_policy">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
